import { React } from "react";
import RegisterComp from "../../components/Register/Register";

function Register() {
    return <RegisterComp />;
}

export default Register;
